import { jsx } from "@builder.io/qwik/jsx-runtime";
import { HAccordionRootImpl } from "./accordion-root.qwik.mjs";
import { findComponent, processChildren } from "../../utils/inline-component.qwik.mjs";
import { HAccordionItem } from "./accordion-item.qwik.mjs";
const HAccordionRoot = (props) => {
  const { children, accordionItemComponent: GivenItem, value: initialValue, ...rest } = props;
  const Item = GivenItem || HAccordionItem;
  let currItemIndex = 0;
  let initialIndex = null;
  const itemsMap = /* @__PURE__ */ new Map();
  findComponent(Item, (itemProps) => {
    itemProps._index = currItemIndex;
    itemsMap.set(currItemIndex, itemProps.disabled);
    if (initialValue && initialValue === itemProps.value) {
      initialIndex = currItemIndex;
    }
    currItemIndex++;
  });
  processChildren(children);
  return /* @__PURE__ */ jsx(HAccordionRootImpl, {
    initialIndex: initialIndex ?? void 0,
    itemsMap,
    ...rest,
    children: props.children
  });
};
export {
  HAccordionRoot
};
